import { useCallback } from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import { DISPLAY_NAME, useToastContext } from '../toast'
import type { ToastScopedProps } from '../toast.types'

type ToastIconProps = TIconProps & {
  testID?: string
}

export const ToastIcon = (props: ToastIconProps) => {
  const { symbol, __scopeToast } = props as ToastScopedProps<ToastIconProps>

  const { type } = useToastContext(DISPLAY_NAME, __scopeToast)

  const mapper: Record<typeof type, TIconProps['color']> = {
    success: 'colorTextSuccessAlternative',
    informative: 'colorTextInformativeAlternative',
    warning: 'colorTextWarningAlternative',
    danger: 'colorTextDangerAlternative',
    neutral: 'colorTextNeutralDefault',
  }

  const mapVariantColor = useCallback((): TIconProps['color'] => {
    return mapper[type]
  }, [type])

  return (
    <Icon
      symbol={symbol}
      size="small"
      color={mapVariantColor()}
      data-testid="toast-icon"
    />
  )
}
